import { PaymentTerms } from '@round/api';
import { Select } from '@round/ui-kit';
import React, { useState } from 'react';
import { paymentTermOptions } from '../../../../utils/constants';
import { StylesConfig } from 'react-select';

type Props = {
    value: PaymentTerms;
    onChange: (value: PaymentTerms) => Promise<void>;
    readonly?: boolean;
};

const selectStyles: StylesConfig = {
    control: (provided) => ({
        ...provided,
        height: '2rem',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
    }),
    container: (provided) => ({
        ...provided,
        height: '100%',
        width: '10rem',
    }),
    menuList: (provided) => ({
        ...provided,
        overscrollBehavior: 'contain',
    }),
    menuPortal: (provided) => ({
        ...provided,
        overscrollBehavior: 'contain',
    }),
};

const PaymentTermsPicker = ({ value: currentValue, onChange, readonly }: Props) => {
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(
        paymentTermOptions.find((option) => option.value === currentValue)
    );

    const handleChange = async (option: (typeof paymentTermOptions)[number]) => {
        if (option.value === currentValue) {
            return;
        }
        setIsUpdateLoading(true);
        setSelectedOption(option);
        onChange(option.value)
            .catch(() => {
                setSelectedOption(paymentTermOptions.find((option) => option.value === currentValue));
            })
            .finally(() => setIsUpdateLoading(false));
    };

    if (readonly) {
        return <div>{selectedOption?.label || '-'}</div>;
    }

    return (
        <Select
            value={selectedOption}
            options={paymentTermOptions}
            onChange={(opt) => {
                if (opt) {
                    handleChange(opt);
                }
            }}
            isUpdateLoading={isUpdateLoading}
            isDisabled={isUpdateLoading}
            isSearchable={false}
            isClearable={false}
            styles={selectStyles}
        />
    );
};

export default PaymentTermsPicker;
